import gql from 'graphql-tag';

export const FRAGMENT_VISUAL_LANGUAGE = gql`
  fragment VisualLanguage on VisualLanguage {
    id
    name
    status
  }
`;
